<!-- 农机鉴定 -->
<template>
  <div class="vehicle-identify" style="width: 100%; height: 86vh; display: flex; padding-top: 1vh;position: relative;z-index: 2;">
    <div class="left-part">
      <div class="left-first-part">
        <TitleSlot title="鉴定能力" :width="668" :contentHeight="215" backgroundImageSize="header-img-668" :noHeaderMargin="true">
          <LeftFirst :listObj="leftFirstData" v-if="leftFirstData.length > 0"></LeftFirst>
          <div v-else class="empty_panel"></div>
        </TitleSlot>
      </div>

      <div class="left-second-part">
        <TitleSlot title="检验检测资质" :width="336" :contentHeight="236" backgroundImageSize="header-img-334" :noHeaderMargin="true" class="item-margin">
          <LeftSecondFirst :qualificationList ="leftSecondFirstData" v-if="leftSecondFirstData.length > 0"></LeftSecondFirst>
          <div v-else class="empty_panel"></div>
        </TitleSlot>

        <TitleSlot title="省内农机企业鉴定数量" :width="336" :contentHeight="236" backgroundImageSize="header-img-334" :noHeaderMargin="true">
          <LeftSecondSecond :identifyNumber ="leftSecondSecondData" v-if="leftSecondSecondData.length > 0"></LeftSecondSecond>
          <div v-else class="empty_panel"></div>
        </TitleSlot>
      </div>

      <div class="left-third-part">
        <TitleSlot title="国家支持的推广鉴定信息" :width="336" :contentHeight="236" backgroundImageSize="header-img-334" class="item-margin" :noHeaderMargin="true">
          <LeftThirdFrirst :qualificationList ="leftThirdFrirstData" v-if="leftThirdFrirstData.length > 0"></LeftThirdFrirst>
          <div v-else class="empty_panel"></div>
        </TitleSlot>

        <TitleSlot title="鉴定企业及产品" :width="336" :contentHeight="236" backgroundImageSize="header-img-334" :noHeaderMargin="true">
          <LeftThirdSecond :qualificationList ="leftThirdSecondData"  v-if="leftThirdSecondData.length > 0"></LeftThirdSecond>
          <div v-else class="empty_panel"></div>
        </TitleSlot>
      </div>
    </div>

    <div class="top-part">
      <div class="first-row">
        <p>鉴定受理/完成情况</p>
        <div class="num-box">
          <span class="left common-left-font">{{totalStatistics.total.slCount || 0}}</span>
          <span class="middle">/</span>
          <span class="left common-right-font">{{totalStatistics.total.wcCount || 0}}</span>
        </div>
      </div>

      <div class="line"></div>
      <div class="second-row">
        <div class="item">
          <div class="item-top">国家支持的农业机械推广鉴定</div>
          <div class="item-bottom">
            <span class="common-left-font" :data-content="numberSeparatorCompute(totalStatistics.countryIdentify.slCount || 0)">{{totalStatistics.countryIdentify.slCount || 0 | toThousandFilter}}</span>
            <span class="middle">/</span>
            <span class="common-right-font" :data-content="numberSeparatorCompute(totalStatistics.countryIdentify.wcCount || 0)">{{totalStatistics.countryIdentify.wcCount || 0 | toThousandFilter}}</span>
          </div>
        </div>
        <div class="vertical-line"></div>
        <div class="item">
          <div class="item-top">专项鉴定</div>
          <div class="item-bottom">
            <span class="common-left-font" :data-content="numberSeparatorCompute(totalStatistics.specialIdentify.slCount || 0)">{{totalStatistics.specialIdentify.slCount || 0 | toThousandFilter}}</span>
            <span class="middle">/</span>
            <span class="common-right-font" :data-content="numberSeparatorCompute(totalStatistics.specialIdentify.wcCount || 0)">{{totalStatistics.specialIdentify.wcCount || 0 | toThousandFilter}}</span>
          </div>
        </div>
        <div class="vertical-line"></div>
        <div class="item">
          <div class="item-top">证书变更</div>
          <div class="item-bottom">
            <span class="common-left-font" :data-content="numberSeparatorCompute(totalStatistics.certificateChange.slCount || 0)">{{totalStatistics.certificateChange.slCount || 0 | toThousandFilter}}</span>
            <span class="middle">/</span>
            <span class="common-right-font" :data-content="numberSeparatorCompute(totalStatistics.certificateChange.wcCount || 0)">{{totalStatistics.certificateChange.wcCount || 0 | toThousandFilter}}</span>
          </div>
        </div>
      </div>
      <div class="line"></div>
      <div class="third-row">
        <div class="item">
          <div class="item-top">省级农业机械推广鉴定</div>
          <div class="item-bottom">
            <span class="common-left-font" :data-content="numberSeparatorCompute(totalStatistics.provinceIdentify.slCount || 0)">{{totalStatistics.provinceIdentify.slCount || 0 | toThousandFilter}}</span>
            <span class="middle">/</span>
            <span class="common-right-font" :data-content="numberSeparatorCompute(totalStatistics.provinceIdentify.wcCount || 0)">{{totalStatistics.provinceIdentify.wcCount || 0 | toThousandFilter}}</span>
          </div>
        </div>
        <div class="vertical-line"></div>
        <div class="item">
          <div class="item-top">委托检验</div>
          <div class="item-bottom">
            <span class="common-left-font" :data-content="numberSeparatorCompute(totalStatistics.commission.slCount || 0)">{{totalStatistics.commission.slCount || 0 | toThousandFilter}}</span>
            <span class="middle">/</span>
            <span class="common-right-font" :data-content="numberSeparatorCompute(totalStatistics.commission.wcCount || 0)">{{totalStatistics.commission.wcCount || 0 | toThousandFilter}}</span>
          </div>
        </div>
        <div class="vertical-line"></div>
        <div class="item">
          <div class="item-top">到期换证</div>
          <div class="item-bottom">
            <span class="common-left-font" :data-content="numberSeparatorCompute(totalStatistics.becomeDue.slCount || 0)">{{totalStatistics.becomeDue.slCount || 0 | toThousandFilter}}</span>
            <span class="middle">/</span>
            <span class="common-right-font" :data-content="numberSeparatorCompute(totalStatistics.becomeDue.wcCount || 0)">{{totalStatistics.becomeDue.wcCount  || 0 | toThousandFilter}}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="right-part"></div>

    <ChosePage class="chose-page"></ChosePage>

    <!-- 地图 -->
    <div class="map_container">
      <MapModel ref="mapModel" :areaInfoList="areaInfoList" />
    </div>

  </div>
</template>

<script>
import * as purchaseAllowanceApi from "@/api/governmentAffairs/purchaseAllowance.js";
import * as vehicleIdentify from "@/api/governmentAffairs/vehicleIdentify.js";
import { mapGetters } from "vuex";
import TitleSlot from '../components/TitleSlot'
import ChosePage from '../components/ChosePage'
import LeftFirst from './components/LeftFirst'
import LeftSecondFirst from './components/LeftSecondFirst'
import LeftSecondSecond from './components/LeftSecondSecond'
import LeftThirdFrirst from './components/LeftThirdFrirst'
import LeftThirdSecond from './components/LeftThirdSecond'
import MapModel from './components/MapModel'

export default {
  components: {
    TitleSlot,
    ChosePage,
    LeftFirst,
    LeftSecondFirst,
    LeftSecondSecond,
    LeftThirdFrirst,
    LeftThirdSecond,
    MapModel
  },
  data() {
    return {
      commonParams: {
        year: 2025
      },
      // 顶部6项数据
      totalStatistics: {},
      // 顶部6项数据
      copyTotalStatistics: {
        //鉴定受理/完成情况
        total: {
          slCount: 0,
          wcCount: 0,
        },
        // 国家支持的农业机械推广鉴定
        countryIdentify: {
          slCount: 0,
          wcCount: 0,
        },
        // 专项鉴定
        specialIdentify: {
          slCount: 0,
          wcCount: 0,
        },
        // 证书变更
        certificateChange: {
          slCount: 0,
          wcCount: 0,
        },
        // 省级农业机械推广鉴定
        provinceIdentify: {
          slCount: 0,
          wcCount: 0,
        },
        // 委托检验
        commission: {
          slCount: 0,
          wcCount: 0,
        },
        // 到期换证
        becomeDue: {
          slCount: 0,
          wcCount: 0,
        },
      },
      leftFirstData: [],
      leftSecondFirstData: [],
      leftSecondSecondData: [],
      leftThirdFrirstData: [],
      leftThirdSecondData: [],
      areaInfoList: [],
    };
  },
  watch: {
    "$store.state.activeRegionObj": {
      deep: true,
      immediate: true,
      handler(val) {
        if (!val.areaCode) return;
        this.isProvinceLevel = val.areaCode == "410000000";
        this.initPageData();
        this.getLastUpdateTime();
        const city = val.areaCode.slice(0, -3);
        // this.$nextTick(() => {
        //   if (this.$refs.mapModel) {
        //     this.$refs.mapModel.addProvince(city);
        //   }
        // });
      },
    },
    "$store.state.activeYear": {
      // deep: true,
      // immediate: true,
      handler(val) {
        this.commonParams.year = val;
        this.initPageData();
      },
    },
  },
  computed: {
    ...mapGetters(['getActiveYear']),
    numberSeparatorCompute() {
      return function(number){
        let regex = /(?!^)(?=(\d{3})+(\.|$))/g;
        if (!number) {
          return 0;
        }else {
          return number.toFixed().replace(regex, ',');
        }
      }
    },

  },
  name: "vehicleIdentify",
  created() {
    this.totalStatistics = Object.assign({}, this.copyTotalStatistics);
  },
  methods: {
    initPageData() {
      this.getJDStatisticsList();
      this.getAppraiseOutlineList();
      this.getAptitudeList();
      this.getEnterpriseAppraiseList();
      this.getCountrySupportList();
      this.getEnterpriseProductList();
      this.getAppraiseProvinceList();
      // this.getLastUpdateTime();
    },
    //获取最后一次跟新时间
    getLastUpdateTime() {
      purchaseAllowanceApi.getLastUpdateTime('JD').then((res) => {
        this.$store.dispatch("setLastUpdateTime", res || '');
      })
    },
    // 仪表盘-各区域年度补贴机具数量统计 (顶部6项数据)
    getJDStatisticsList() {
      vehicleIdentify.getJDStatisticsList(this.commonParams).then((res) => {
        let result = res || [];
        this.totalStatistics = Object.assign({}, this.copyTotalStatistics);
        res.forEach(item => {
          this.convertFormat(item);
        })
      })
    },
    // 鉴定能力列表
    getAppraiseOutlineList() {
      vehicleIdentify.getAppraiseOutlineList(this.commonParams).then((res) => {
        this.leftFirstData = res || [];
      })
    },
    // 检验检测资质
    getAptitudeList() {
      vehicleIdentify.getAptitudeList(this.commonParams).then((res) => {
        this.leftSecondFirstData = res || [];
      })
    },
    // 各农机企业鉴定数量
    getEnterpriseAppraiseList() {
      vehicleIdentify.getEnterpriseAppraiseList(this.commonParams).then((res) => {
        this.leftSecondSecondData = res || [];
      })
    },
    // 国家支持的推广鉴定信息
    getCountrySupportList() {
      vehicleIdentify.getCountrySupportList(this.commonParams).then((res) => {
        this.leftThirdFrirstData = res || [];
      })
    },
    // 申请省级鉴定企业及产品
    getEnterpriseProductList() {
      vehicleIdentify.getEnterpriseProductList(this.commonParams).then((res) => {
        let result = res || [];
        result.forEach(item => {
          if(item.status) {
            this.turnCode(item, 'status');
          }
          if(item.type) {
            this.turnCode(item, 'type');
          }
        })
        this.leftThirdSecondData = result;
      })
    },
    // 省份列表（地图）
    getAppraiseProvinceList() {
      vehicleIdentify.getAppraiseProvinceList(this.commonParams).then((res) => {
        this.areaInfoList = res || [];
      })
    },
    // 转换为状态值
    turnCode(item, type='status') {
      if(type == 'status') {
        switch (item.status) {
          case '受理':
            item.statusCode = 'sl'
            break;
          case '完成':
            item.statusCode = 'wc'
            break;
          case '终止':
            item.statusCode = 'zz'
            break;
          default:
            break;
        }
      }else {
        switch (item.type) {
          case '国家支持的农业机械推广鉴定':
            item.typeCode = 'gt'
            break;
          case '省级农业机械推广鉴定':
            item.typeCode = 'st'
            break;
          case '到期换证':
            item.typeCode = 'dqhz'
            break;
          case '委托检验':
            item.typeCode = 'wtjy'
            break;
          case '专项鉴定':
            item.typeCode = 'zyjd'
            break;
          default:
            break;
        }
      }
    },
    // 把顶部数据转为需要格式
    convertFormat(item) {
      switch (item.name) {
        case '鉴定受理/完成情况':
          this.totalStatistics.total = {
            slCount: item.slCount,
            wcCount: item.wcCount,
          }
          break;
        case '国家支持的农业机械推广鉴定':
          this.totalStatistics.countryIdentify = {
            slCount: item.slCount,
            wcCount: item.wcCount,
          }
          break;
        case '专项鉴定':
          this.totalStatistics.specialIdentify = {
            slCount: item.slCount,
            wcCount: item.wcCount,
          }
          break;
        case '证书变更':
          this.totalStatistics.certificateChange = {
            slCount: item.slCount,
            wcCount: item.wcCount,
          }
          break;
        case '省级农业机械推广鉴定':
          this.totalStatistics.provinceIdentify = {
            slCount: item.slCount,
            wcCount: item.wcCount,
          }
          break;
        case '委托检验':
          this.totalStatistics.commission = {
            slCount: item.slCount,
            wcCount: item.wcCount,
          }
          break;
        case '到期换证':
          this.totalStatistics.becomeDue = {
            slCount: item.slCount,
            wcCount: item.wcCount,
          }
          break;
        default:
          break;
      }
    },

  }
};
</script>
<style scoped lang="scss">
@function vw($px) {
  @return ($px / 1920) * 100vw;
}
@function vh($px) {
  @return ($px / 1080) * 100vh;
}
@function fontSize($px) {
  @return 100vw * $px / 1920;
}

.left-part {
  z-index: 2;
  width: vw(668);
  margin-left: vw(10);
  font-family: Microsoft YaHei;
  font-size: fontSize(14);
  .left-first-part {

  }
  .left-second-part {
    display: flex;
    margin-top: vh(12);
    margin-bottom: vh(10);
  }
  .left-third-part {
    display: flex;
  }
  .item-margin {
    margin-right: vh(10);
  }
}

.top-part {
  z-index: 1;
  width: vw(629);
  height: vh(151);
  margin-top: vh(10);
  margin-left: vw(30);
  padding: vh(1) vw(16) vh(8) vw(16);
  background-image: url("../../../assets/images/governmentAffairs/vehicleIdentify/bg_bata_jd.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  font-family: Microsoft YaHei;
  font-size: fontSize(14);
  color: #EFFFF5;
  .first-row {
    display: flex;
    align-items: center;
    .num-box {
      height: vh(35);
      line-height: vh(35);
      margin-left: vw(24);
      .middle {
        color: #1E6C39;
        font-size: fontSize(22);
        margin-right: vw(2);
      }
    }
  }
  .second-row {
    display: flex;
  }
  .third-row {
    display: flex;
  }
  .common-left-font {
    position: relative;
    padding-right: vw(6);
    font-family: Rajdhani;
    font-weight: 600;
    font-size: fontSize(26);
    font-style: italic;
    background: linear-gradient(180deg, #FFFFFF 20%, #BDFFCC 80%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .common-left-font::before {
    content: attr(data-content);
    position: absolute;
    top: 0;
    left: 0;
    color: transparent;
    text-shadow: 0px 3px 7px rgba(0,0,0,0.35);
  }
  .common-right-font {
    position: relative;
    font-family: Rajdhani;
    padding-right: vw(6);
    font-weight: 600;
    font-size: fontSize(26);
    font-style: italic;
    background: linear-gradient(0deg, #F7D58F 0%, #FFFFFF 80%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .common-right-font::before {
    content: attr(data-content);
    position: absolute;
    top: 0;
    left: 0;
    color: transparent;
    text-shadow: 0px 3px 7px rgba(0,0,0,0.35);
  }
  .line {
    height: vh(1);
    margin-bottom: vh(4);
    background: linear-gradient(90deg, rgba(54,158,120,0), rgba(54,158,120,1), rgba(54,158,120,0));
  }

  .item {
    flex: 1;
    .item-top {
      font-family: Microsoft YaHei;
      font-size: fontSize(14);
      color: #EFFFF5;
    }
    .item-bottom {
      display: flex;
      align-items: center;
      height: vh(32);
      line-height: vh(32);
      .middle {
        color: #2EB781;
        font-size: fontSize(18);
        padding-bottom: vh(4);
      }
    }
  }
  
  .vertical-line {
    width: vw(1);
    height: vh(42);
    margin-top: vh(4);
    margin-right: vw(10);
    background-image: url("../../../assets/images/governmentAffairs/vehicleIdentify/bg_titlemenu_nl_line.png");
    background-size: 100%;
    background-repeat: no-repeat;
  }
}

.right-part {
  z-index: 1;
  position: absolute;
  right: vw(106);
  bottom: vh(28);
  width: vw(160);
  height: vh(205);
  background-image: url("../../../assets/images/governmentAffairs/vehicleIdentify/pic_nhzd.png");
  background-size: 100%;
  background-repeat: no-repeat;
}

.chose-page {
  position:absolute;
  bottom: vh(18);
  left: vw(700);
  width: vw(530);
  height: vh(116);
  z-index: 1;
}

.map_container {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  width: 100%;
  background: url("../../../assets/images/governmentAffairs/vehicleIdentify/bg.gif") no-repeat;
  background-size: 100% 100%;
}
</style>
